export const companyMixin = {
    data() {
        return {
            csrf: '',
        }
    },
    computed: {
    },
    mounted() {
        this.csrf = document.head.querySelector('meta[name="csrf-token"]').content;
    },
    methods: {
        buildCompanyRoute(inputRoute){
            return "/" + this.getCompanyId() + "/" + inputRoute;
        },
        buildCompanyApiInternalRoute(inputRoute, company = null){
            return "/api-internal/" + this.getCompanyId() + "/" + inputRoute;
        },
        getCompanyId(){
            let path = window.location.pathname.split('/');
            return path[1];
        }
    }
}
